import { Report195 } from "../../../components/borrowSystem/Report/Report195";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";
import { NavbarBorrowSystem } from "../../../components/share/NavbarBorrowSystem";

export function Report195Container() {
  const titleName = "  สรุปข้อมูลการชำระคืนเงินกู้ยืมกองทุนพัฒนาฝีมือแรงงาน"; //ใส่ชื่อtitle ตรงนี้
  return (
    <div className="page-container bg-landing">
      <NavbarBorrowSystem />
      <HeadTitle title={titleName} />
      <Report195 />
      <Footer />
    </div>
  );
}
